import { getPatternStyles, patternFns } from './runtime.mjs';
import { memo } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const boxConfig = { transform(props) {
  return props;
} }

export function boxRaw(styles) {
  const s = getPatternStyles(boxConfig, styles || {})
  return boxConfig.transform(s, patternFns)
}

export const box = /* @__PURE__ */ Object.assign(/* @__PURE__ */ memo(function box(styles = {}) {
  return css(boxRaw(styles))
}), { raw: boxRaw, propKeys: [] })